'use client';

import { usePathname, useRouter } from 'next/navigation';
import { checkLogin } from 'src/utils/auth';

import NotificationBar from '@/app/(football)/[team]/_components/common/NotificationBar';
import { useTeamConfig } from '@/app/(football)/[team]/_context/context';
import type { NotificationRoutes } from '@/app/(football)/[team]/_context/types';

interface MainNotificationBarProps {
  notificationData?: {
    type: 'welcome' | 'attendance' | 'minigame' | 'lounge' | null;
    label: string | null;
  };
  notificationRoutes: NotificationRoutes;
}

export default function MainNotificationBar({
  notificationData,
  notificationRoutes,
}: MainNotificationBarProps) {
  const router = useRouter();
  const pathname = usePathname();
  const { teamSlug } = useTeamConfig();

  if (!notificationData?.type || !notificationData?.label) {
    return null;
  }

  const handleClick = () => {
    if (!checkLogin()) {
      router.push(`/account/login?retUrl=${pathname}`);
      return;
    }

    if (notificationRoutes[notificationData.type!]) {
      router.push(`/${teamSlug}${notificationRoutes[notificationData.type!]}`);
    }
  };

  const iconUrl = `https://cdn.kottonseed.io/assets/football/2026/${teamSlug}/icons/icon_illust_clay_${notificationData.type}.webp`;

  return (
    <NotificationBar
      iconUrl={iconUrl}
      label={notificationData.label}
      onClick={handleClick}
    />
  );
}
